import { useState } from 'react';
import { Common } from '@thecvlb/design-system/lib/src';

import FAQ from 'modals/FAQ';

import { ResultsProps } from './results.types';

const Results: React.FC<ResultsProps> = ({ onContinue, userCurrentPPType }) => {
  const [isFAQOpen, setIsFAQOpen] = useState(false);

  return (
    <div className="flex grow flex-col gap-6 max-md:h-full">
      <FAQ
        isOpen={isFAQOpen}
        type="eligible"
        onClose={() => setIsFAQOpen(false)}
        screen="qualified-for-sema-plus"
        planType={userCurrentPPType}
        medication="semaglutide"
      />
      <div className="flex flex-col items-center gap-2 text-center max-md:py-6">
        <Common.Illustration name="success" />
        <h4 className="font-bold text-primary">Great news!</h4>
        <h3 className="text-m2xl font-bold text-primary-700 md:text-2xl">
          You may be eligible for a custom compound
        </h3>
        <div>
          <span className="mb-1 block text-center font-bold text-primary">What to expect:</span>
          <span>
            No action is required on your part. Based on your medical intake, you may be prescribed
            a modified compounded formulation of semaglutide, with patient-specific benefits.
          </span>
        </div>
        <button className="font-bold" onClick={() => setIsFAQOpen(true)}>
          View FAQs
        </button>
      </div>
      <div className="mt-auto flex flex-col items-center gap-3 max-md:py-6 md:self-center">
        <Common.Button color="blue" fullWidthOnMobile onClick={() => onContinue(true)}>
          Continue
        </Common.Button>
        <Common.Button color="white-alt" fullWidthOnMobile onClick={() => onContinue(false)}>
          Discuss with my provider
        </Common.Button>
      </div>
    </div>
  );
};

export default Results;
